import { ThemeProvider } from "styled-components";
import { darkTheme, lightTheme } from "./styles/theme";
import { Routes, Route, useLocation } from "react-router-dom";
import { useState } from "react";
import Home from "./pages/Home/Home";
import { GlobalStyle } from "./styles/globalStyles";
import { LayoutMain } from "./layout/styles";
import Header from "./components/Header/Header";
import About from "./pages/About/About";
import Skills from "./pages/Skills/Skills";
import Projects from "./pages/Projects/Projects";
import { AnimatePresence } from "framer-motion";
import Contact from "./pages/Contact/Contact";
import CardExpanded from "./components/ProjectCard/CardExpanded";
import ScrollTop from "./components/ScrollTop/ScrollTop";
import { useThemeStorage } from "./components/useThemeStorage";

function App() {
	const [theme, themeToggler] = useThemeStorage();
	const currentTheme = theme === "light" ? lightTheme : darkTheme;
	const location = useLocation();

	return (
		<ThemeProvider theme={currentTheme}>
			<GlobalStyle />
			<Header theme={theme} setTheme={themeToggler} />
			<LayoutMain>
				<ScrollTop />
				<AnimatePresence initial={false} exitBeforeEnter>
					<Routes location={location} key={location.pathname.split("/")[1]}>
						<Route path='/' element={<Home />} />
						<Route path='about' element={<About />} />
						<Route path='skills' element={<Skills />} />
						<Route path='contact' element={<Contact />} />
						<Route path='projects' element={<Projects />}>
							<Route path=':id' element={<CardExpanded />} />
						</Route>
					</Routes>
				</AnimatePresence>
			</LayoutMain>
		</ThemeProvider>
	);
}

export default App;
